import {
  Typography,
  Stack,
  IconButton,
  Select,
  MenuItem,
  TextField,
  Button,
  Chip,
} from "@mui/material"
import { useState } from "react"
import Modal from "../ui/Modal"
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded"
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded"

const SetQuestionsModal = (props) => {
  const [questions, setQuestions] = useState([
    {
      question: "",
      marks: "",
      type: "MCQ",
      answers: [],
    },
  ])
  const handleChange = (ev, i) => {
    const { name, value } = ev.target
    setQuestions([
      ...questions.slice(0, i),
      {
        ...questions[i],
        [name]: value,
      },
      ...questions.slice(i + 1),
    ])
  }
  const addAnswer = (ans, i) => {
    setQuestions([
      ...questions.slice(0, i),
      {
        ...questions[i],
        answers: [
          ...questions[i].answers,
          {
            text: ans,
            correct: false,
          },
        ],
      },
      ...questions.slice(i + 1),
    ])
  }
  const markCorrect = (i, ansIdx) => {
    setQuestions([
      ...questions.slice(0, i),
      {
        ...questions[i],
        answers: [
          ...questions[i].answers.slice(0, ansIdx),
          {
            ...questions[i].answers[ansIdx],
            correct: !questions[i].answers[ansIdx].correct,
          },
          ...questions[i].answers.slice(ansIdx + 1),
        ],
      },
      ...questions.slice(i + 1),
    ])
  }
  const removeAns = (i, ansIdx) => {
    setQuestions([
      ...questions.slice(0, i),
      {
        ...questions[i],
        answers: questions[i].answers.filter((_, ai) => ai !== ansIdx),
      },
      ...questions.slice(i + 1),
    ])
  }
  const addQuestion = () =>
    setQuestions([
      ...questions,
      {
        question: "",
        marks: "",
        type: "MCQ",
        answers: [],
      },
    ])
  const removeQuestion = (i) =>
    setQuestions(questions.filter((_, idx) => idx !== i))

  return (
    <Modal {...props} title="Set Questions" actionText="Finish">
      <Stack marginBottom={2} spacing={2}>
        {questions.map((q, i) => (
          <Question
            key={i}
            number={i + 1}
            data={q}
            handleChange={(e) => handleChange(e, i)}
            remove={() => removeQuestion(i)}
            addAnswer={(ans) => addAnswer(ans, i)}
            markCorrect={(ai) => markCorrect(i, ai)}
            removeAns={(ai) => removeAns(i, ai)}
          />
        ))}
      </Stack>
      <Button onClick={addQuestion} variant="contained" fullWidth>
        Add another question
      </Button>
    </Modal>
  )
}

const Question = ({
  number,
  data,
  handleChange,
  remove,
  addAnswer,
  markCorrect,
  removeAns,
}) => {
  const { type, marks, question, answers } = data
  const [ans, setAns] = useState("")
  return (
    <Stack
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.06)",
        borderRadius: 2,
        pt: 1,
        pb: 2,
        px: 2,
      }}
      spacing={2}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Question {number}</Typography>
        <IconButton onClick={remove}>
          <DeleteRoundedIcon fontSize="large" />
        </IconButton>
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Select
          sx={{ width: "8rem" }}
          name="type"
          value={type}
          onChange={handleChange}
        >
          <MenuItem value="MCQ">MCQ</MenuItem>
          <MenuItem value="Subjective">Subjective</MenuItem>
        </Select>
        <TextField
          name="marks"
          value={marks}
          onChange={handleChange}
          sx={{ width: "5rem" }}
          label="Marks"
          type="number"
        />
      </Stack>
      <TextField
        name="question"
        value={question}
        onChange={handleChange}
        label="Enter the question"
      />
      {type === "MCQ" && (
        <>
          <Stack direction="row" spacing={2} alignItems="center">
            <TextField
              value={ans}
              onChange={(e) => setAns(e.target.value)}
              label="Enter a possible answer"
              fullWidth
            />
            <IconButton
              onClick={() => {
                addAnswer(ans)
                setAns("")
              }}
            >
              <AddCircleRoundedIcon fontSize="large" />
            </IconButton>
          </Stack>
          <Stack direction="row" spacing={2} flexWrap="wrap">
            {answers.map((a, i) => (
              <Chip
                label={a.text}
                color={a.correct ? "success" : "default"}
                onClick={() => markCorrect(i)}
                onDelete={() => removeAns(i)}
              />
            ))}
          </Stack>
          {!!answers.length && (
            <Typography variant="caption" color="text.secondary">
              Click on an answer to mark it as correct
            </Typography>
          )}
        </>
      )}
    </Stack>
  )
}

export default SetQuestionsModal
